import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

//**import assets */
import { LocationIcon } from '@src/assets/svg/icons';

//**import components */
import Button from '@src/components/shared/Button';
import Typography from '@src/components/shared/Typography';
import ModalForm from '@src/components/ModalForm';

export const JobDetails = () => {
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const [job, setJob] = useState(null);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [show]);

  useEffect(() => {
    const fetchJob = async () => {
      const url = process.env.REACT_APP_FETCHING_API_TESTING
      try {
        const response = await axios.post(
          // `http://localhost:5000/api/getCareerById/${id}`,
          url + `/getCareerById/${id}`,
        );
        setJob(response.data.data);
      } catch (error) {
        console.error('Error fetching job details:', error);
      }
    };

    fetchJob();
  }, [id]);

  // If job is not found, return null or some error message
  if (!job) {
    return <div>Loading...</div>;
  }

  // Create a new Date object from the string
  const date = new Date(job?.createdAt);

  // Get day, month, and year
  const day = date.getDate();
  const month = date.getMonth() + 1; // getMonth() returns 0-indexed month, so add 1
  const year = date.getFullYear();

  // Format day and month to two digits if needed
  const formattedDay = day < 10 ? `0${day}` : `${day}`;
  const formattedMonth = month < 10 ? `0${month}` : `${month}`;

  // Format the date as DD/MM/YYYY
  const formattedDate = `${formattedDay}/${formattedMonth}/${year}`;

  return (
    <div className="bg-dim-gray h-full">
      {show && <ModalForm setShow={setShow} jobTitle={job.job_name} />}
      <div className=" h-full w-10/12 md:w-3/5 py-[7.5rem] mx-auto">
        <Typography variant="P_SemiBold_H2" className="text-primary-black flex">
          {job.job_name}
        </Typography>
        <div className="flex md:flex-row flex-col items-start  md:items-center">
          <div className="flex">
            <LocationIcon size={18} />
            <Typography variant="P_SemiBold_H6" className="pl-4">
              Location:
            </Typography>
            <Typography className="md:pr-4"> {job.location} </Typography>
          </div>
          <div className="flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M24 7.92188C24 6.35578 24 5.26017 24 5.15625C24 3.99314 23.0537 3.04688 21.8906 3.04688H21.6094V5.625C21.6094 6.01331 21.2946 6.32812 20.9062 6.32812C20.5179 6.32812 20.2031 6.01331 20.2031 5.625C20.2031 4.83567 20.2031 2.661 20.2031 1.875C20.2031 1.48669 19.8883 1.17188 19.5 1.17188C19.1117 1.17188 18.7969 1.48669 18.7969 1.875V3.04688H14.1094V5.625C14.1094 6.01331 13.7946 6.32812 13.4062 6.32812C13.0179 6.32812 12.7031 6.01331 12.7031 5.625C12.7031 4.83567 12.7031 2.661 12.7031 1.875C12.7031 1.48669 12.3883 1.17188 12 1.17188C11.6117 1.17188 11.2969 1.48669 11.2969 1.875V3.04688H6.60938V5.625C6.60938 6.01331 6.29456 6.32812 5.90625 6.32812C5.51794 6.32812 5.20312 6.01331 5.20312 5.625C5.20312 4.83567 5.20312 2.661 5.20312 1.875C5.20312 1.48669 4.88831 1.17188 4.5 1.17188C4.11169 1.17188 3.79688 1.48669 3.79688 1.875V3.04688H2.10938C0.946266 3.04688 0 3.99314 0 5.15625V7.92188H24Z"
                fill="#0176D3"
              />
              <path
                d="M0 9.32812V20.7188C0 21.8819 0.946266 22.8281 2.10938 22.8281H21.8906C23.0537 22.8281 24 21.8819 24 20.7188C24 20.4176 24 13.8369 24 9.32812C23.5624 9.32812 0.242063 9.32812 0 9.32812ZM6.75 19.0781H5.25C4.86169 19.0781 4.54688 18.7633 4.54688 18.375C4.54688 17.9867 4.86169 17.6719 5.25 17.6719H6.75C7.13831 17.6719 7.45312 17.9867 7.45312 18.375C7.45312 18.7633 7.13831 19.0781 6.75 19.0781ZM6.75 16.0781H5.25C4.86169 16.0781 4.54688 15.7633 4.54688 15.375C4.54688 14.9867 4.86169 14.6719 5.25 14.6719H6.75C7.13831 14.6719 7.45312 14.9867 7.45312 15.375C7.45312 15.7633 7.13831 16.0781 6.75 16.0781ZM6.75 13.0781H5.25C4.86169 13.0781 4.54688 12.7633 4.54688 12.375C4.54688 11.9867 4.86169 11.6719 5.25 11.6719H6.75C7.13831 11.6719 7.45312 11.9867 7.45312 12.375C7.45312 12.7633 7.13831 13.0781 6.75 13.0781ZM12.75 19.0781H11.25C10.8617 19.0781 10.5469 18.7633 10.5469 18.375C10.5469 17.9867 10.8617 17.6719 11.25 17.6719H12.75C13.1383 17.6719 13.4531 17.9867 13.4531 18.375C13.4531 18.7633 13.1383 19.0781 12.75 19.0781ZM12.75 16.0781H11.25C10.8617 16.0781 10.5469 15.7633 10.5469 15.375C10.5469 14.9867 10.8617 14.6719 11.25 14.6719H12.75C13.1383 14.6719 13.4531 14.9867 13.4531 15.375C13.4531 15.7633 13.1383 16.0781 12.75 16.0781ZM12.75 13.0781H11.25C10.8617 13.0781 10.5469 12.7633 10.5469 12.375C10.5469 11.9867 10.8617 11.6719 11.25 11.6719H12.75C13.1383 11.6719 13.4531 11.9867 13.4531 12.375C13.4531 12.7633 13.1383 13.0781 12.75 13.0781ZM18.75 19.0781H17.25C16.8617 19.0781 16.5469 18.7633 16.5469 18.375C16.5469 17.9867 16.8617 17.6719 17.25 17.6719H18.75C19.1383 17.6719 19.4531 17.9867 19.4531 18.375C19.4531 18.7633 19.1383 19.0781 18.75 19.0781ZM18.75 16.0781H17.25C16.8617 16.0781 16.5469 15.7633 16.5469 15.375C16.5469 14.9867 16.8617 14.6719 17.25 14.6719H18.75C19.1383 14.6719 19.4531 14.9867 19.4531 15.375C19.4531 15.7633 19.1383 16.0781 18.75 16.0781ZM18.75 13.0781H17.25C16.8617 13.0781 16.5469 12.7633 16.5469 12.375C16.5469 11.9867 16.8617 11.6719 17.25 11.6719H18.75C19.1383 11.6719 19.4531 11.9867 19.4531 12.375C19.4531 12.7633 19.1383 13.0781 18.75 13.0781Z"
                fill="#0176D3"
              />
            </svg>
            <Typography className="ps-3">
              {' '}
              Job Post Date: {formattedDate}
            </Typography>
          </div>
        </div>
        <div className="bg-white mt-16 p-6 rounded-lg">
          <Typography
            variant="P_SemiBold_H4"
            className="block pb-6 text-primary-black "
          >
            Job Description.
          </Typography>
          <Typography
            variant="P_Regular_H6"
            className="block pb-6 text-mid-black"
          >
            {job.job_description}
          </Typography>
          <Typography variant="P_Regular_H6" className="block text-mid-black">
            Abhar Tech is a leading global information technology, consulting
            and business process services company.
          </Typography>
          <Typography
            variant="P_SemiBold_H4"
            className="block pt-8 pb-6 text-primary-black"
          >
            Responsibilities.
          </Typography>

          {job.responsibilities && (
            <ul className="list-disc px-6 text-mid-black">
              {job.responsibilities.map((responsibility, index) => (
                <li key={index}>{responsibility}</li>
              ))}
            </ul>
          )}
          <Button className="md:mt-12 mt-6" onClick={() => setShow(true)}>
            Apply now
          </Button>
        </div>
      </div>
    </div>
  );
};
